<template>
  <div style="u">
    <a-table :loading="loading" :scroll="{ y: 340 }" :show-header="true" :pagination="false" :data-source="taskList" size="small">
      <a-table-column title="名称">
        <template slot-scope="text, record">
          <a-tag v-if="record.type === 'task'" color="#108ee9">任务</a-tag>
          <a-tag v-else-if="record.type === 'req'" color="#87d068">需求</a-tag>
          <a v-if="record.type === 'req'" class="custom-link" target="_blank" @click="openTitle(record)">{{ record.issueName }}</a>
          <a v-else-if="record.type === 'task'" class="custom-link" target="_blank" @click="openTitle(record)">{{ record.issueName }}</a>
        </template>
      </a-table-column>
      <a-table-column title="工作类型" width="80px">
        <template slot-scope="text, record">
          {{ record.workType === 'dev' ? '开发' : '质量验收' }}
        </template>
      </a-table-column>
    </a-table>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import { getUserWorkInfo } from '@/api/datacenter/datacenter';
export default {
  props: {
    userId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      taskList: []
    };
  },
  created() {
    this.getTaskList();
  },
  methods: {
    openTitle(record) {
      if (record.type === 'task') {
        const url = this.$router.resolve({
          name: 'page:project:task:detail',
          params: { project_id: record.projectId },
          query: { taskId: record.issueId }
        }).href;
        window.open(url, '_blank');
      } else if (record.type === 'req') {
        const url = this.$router.resolve({
          name: 'page:project:story:detail',
          params: { project_id: record.projectId },
          query: { storyId: record.issueId }
        }).href;
        window.open(url, '_blank');
      }
    },
    getTaskList() {
      this.loading = true;
      this.taskList = [];
      getUserWorkInfo({
        about: 1,
        userList: [this.userId],
        teamList: [],
        beginTime: dayjs().format('YYYY-MM-DD') + ' 00:00:00',
        endTime: dayjs().format('YYYY-MM-DD') + ' 23:59:59'
      })
        .then(res => {
          for (const users of Object.values(res.data)) {
            for (const item of Object.values(users.userWorkMap)) {
              if (Array.isArray(item.workInfoList)) {
                this.taskList = [...this.taskList, ...item.workInfoList];
              }
            }
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style scoped>
:deep(.ant-table-fixed-header .ant-table-scroll .ant-table-header) {
  padding-bottom: 0;
}
:deep(.ant-table-small) {
  border: 0;
}
</style>
